import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

/** Renders the Google Identity Services button and exchanges the credential for a session. */
export function GoogleSignInButton({ onError }: { onError?: (message: string) => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const { loginWithGoogle } = useAuth();
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  useEffect(() => {
    const g = window.google;
    if (!g || !ref.current || !clientId) return;

    g.accounts.id.initialize({
      client_id: clientId,
      hd: 'zce-group.com',
      callback: async (resp: { credential: string }) => {
        try {
          await loginWithGoogle(resp.credential);
        } catch (e) {
          onError?.((e as Error).message);
        }
      },
    });
    g.accounts.id.renderButton(ref.current, {
      theme: 'filled_blue',
      size: 'large',
      text: 'signin_with',
      shape: 'pill',
      width: 280,
    });
  }, [clientId, loginWithGoogle, onError]);

  if (!clientId) {
    return <p className="text-red-600 text-sm">VITE_GOOGLE_CLIENT_ID non configure.</p>;
  }
  return <div ref={ref} />;
}
